/* eslint-disable no-nested-ternary */
import { useQuery } from '@apollo/client';
import BaseStructure from 'components/BaseStructure';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import { useRoutesDisplayValues } from 'hooks/useRoutesDisplayValues';
import React from 'react';
import { useHistory } from 'react-router';
import ROUTES from 'routes/routeConstants';
import { findSpecificTransactionTypeByUser } from 'services/graphql/queries/transactionTypes.query';
import { ITransactionType } from 'types/services';

import ActiveAppointmentTabs from './ActiveAppointmentTabs';
import HistoryAppointmentList from './HistoryAppointmentList';

const NotaryAppointments: React.FC = () => {
  const history = useHistory();
  const { location } = history;
  const path = location.pathname;
  const isHistoryAppointments = path.includes(ROUTES.HISTORY_APPOINTMENTS);
  const userId = useCurrentLoggedInUser().id;

  const routeDisplayValuesAll = useRoutesDisplayValues();
  const routeDisplayValue = isHistoryAppointments
    ? routeDisplayValuesAll[ROUTES.HISTORY_APPOINTMENTS]
    : routeDisplayValuesAll[ROUTES.ACTIVE_APPOINTMENTS];

  const { data: transactionTypes } = useQuery<{
    findTransactionTypeEntity: { data: ITransactionType[] };
  }>(findSpecificTransactionTypeByUser, {
    variables: {
      user: userId,
      pagination: { take: 50 },
    },
  });

  const transactionTypesData = transactionTypes?.findTransactionTypeEntity?.data;

  return (
    <BaseStructure mobileThreshold={575} header={routeDisplayValue.text} headerIconName={routeDisplayValue.iconClass}>
      {isHistoryAppointments ? (
        <HistoryAppointmentList transactionTypesData={transactionTypesData} />
      ) : (
        <ActiveAppointmentTabs transactionTypesData={transactionTypesData} />
      )}
    </BaseStructure>
  );
};

export default NotaryAppointments;
